module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/ActionLogRow.ejs -->\n';

    var subType = actionLog.get('subType');
    var isEmployeeUser = ['request', 'cancel'].indexOf(subType) > -1;
    var imageUrl = employee.getImageUrl() || ''

__p+='\n<tr>\n    <td class="min-percent-width v-align-middle">\n        <div class="user-image"\n             style="background-image: url('+
((__t=( imageUrl ))==null?'':_.escape(__t))+
');">\n            <abbr>\n                '+
((__t=( employee.has('imageUrl') ? '' :
                    employee.getNameAbbreviation() ))==null?'':_.escape(__t))+
'\n            </abbr>\n        </div>\n    </td>\n    <td class="max-width-none v-align-middle"\n        data-name="'+
((__t=( isEmployeeUser ? employee.get('fullName') : actionLog.get('userName') ))==null?'':_.escape(__t))+
'"\n        data-leaveType="'+
((__t=( leaveTypeName ))==null?'':_.escape(__t))+
'"\n        data-leaveDateFrom="'+
((__t=( (actionLog.get('metadata') || {}).dateFrom ))==null?'':_.escape(__t))+
'"\n        data-leaveDateTo="'+
((__t=( (actionLog.get('metadata') || {}).dateTo ))==null?'':_.escape(__t))+
'"\n        data-approveStatus="'+
((__t=( subType ))==null?'':_.escape(__t))+
'"\n    >\n        '+
((__t=( isEmployeeUser ? employee.get('fullName') : actionLog.get('userName') ))==null?'':_.escape(__t))+
'\n        <br>\n        <span class="font-bold">\n            '+
((__t=( actionLog.getMetadata() ))==null?'':_.escape(__t))+
' - '+
((__t=( leaveTypeName ))==null?'':_.escape(__t))+
'\n        </span>\n        <br>\n        '+
((__t=( actionLog.getCreatedTime() ))==null?'':_.escape(__t))+
'\n        '+
((__t=( actionLog.getCreatedAt() ))==null?'':_.escape(__t))+
'\n    </td>\n    <td class="text-nowrap min-percent-width v-align-middle text-right hidden-xs">\n        ';
 if (actionLog.getLink(layer)) { 
__p+='\n            <b><a href="'+
((__t=( actionLog.getLink() ))==null?'':_.escape(__t))+
'" class="'+
((__t=( actionLog.getTextColor() ))==null?'':_.escape(__t))+
'">'+
((__t=( actionLog.getApprovalType() ))==null?'':_.escape(__t))+
'</a></b>\n        ';
 } else { 
__p+='\n            <b class="'+
((__t=( actionLog.getTextColor() ))==null?'':_.escape(__t))+
'"></b>'+
((__t=( actionLog.getApprovalType() ))==null?'':_.escape(__t))+
'</b>\n        ';
 } 
__p+='\n    </td>\n    <td class="min-percent-width v-align-middle '+
((__t=( actionLog.getTextColor() ))==null?'':_.escape(__t))+
'">\n        ';
 if (actionLog.getLink(layer)) { 
__p+='\n            <a href="'+
((__t=( actionLog.getLink() ))==null?'':_.escape(__t))+
'" class="'+
((__t=( actionLog.getTextColor() ))==null?'':_.escape(__t))+
'">\n                <i class="fa fa-'+
((__t=( actionLog.getIconClass() ))==null?'':_.escape(__t))+
' fa-lg"></i>\n            </a>\n        ';
 } else { 
__p+='\n            <i class="fa fa-'+
((__t=( actionLog.getIconClass() ))==null?'':_.escape(__t))+
' fa-lg"></i>\n        ';
 } 
__p+='\n    </td>\n</tr>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/ActionLogRow.ejs
// module id = 806
// module chunks = 1